import React from 'react';

const debug = false
// const debug = "FieldMultiselect_InlineValueEmpty"

export default function FieldMultiselect_InlineValueEmpty(props:any) {
    let label = props.field.placeholder;

    // check if all values option is enabled
    if (!!props.field.allValuesOption && !props.options) {
        label = props.field.allValuesOptionLabel;
    }

    const showIcon = _.get(props.configOptions, 'showIcon', true)

    debug && console.log(debug, 'render', showIcon, label, props)

    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-no-accent-default ui5-field-dropdown-inline-editable min-w-125", props.className)} onClick={props.onClick}>
                {showIcon && _.get(props.field.components, 'ValueIcon', false)}
                {label}
            </div>
            {props.children}
        </React.Fragment>
    )
}